<mat-expansion-panel (opened)="panelOpen = true" (closed)="panelOpen = false" hideToggle>
    <mat-expansion-panel-header class="py-5 px-4">
        <mat-panel-title class="d-flex">
            <div class="container d-flex flex-column">
                <h2 class="header-title" [class.complete]="stepIsValid()" [class.error]="stepIsInvalid()">
                    {{ title }}
                </h2>
            </div>
            <div>
                <mat-icon *ngIf="!hasInteractedWithForm && !panelOpen" class="header-toggle">
                    expand_more
                </mat-icon>
                <mat-icon *ngIf="!hasInteractedWithForm && panelOpen" class="header-toggle">
                    expand_less
                </mat-icon>
                <mat-icon *ngIf="stepIsValid()" class="header-toggle complete">
                    checked
                </mat-icon>
                <mat-icon *ngIf="stepIsInvalid()" class="header-toggle error">
                    close
                </mat-icon>
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="mx-2 mb-5">
        <div class="row">
            <div class="col d-flex flex-column">
                <mat-form-field class="form-input" appearance="outline" style="max-width: 200px">
                    <mat-label>Number of Guests</mat-label>
                    <input type="number" min="0" step="1" matInput placeholder="0" (input)="this.onNumberOfGuestsChange()" #numberOfGuests>
                </mat-form-field>
                <table mat-table [dataSource]="dataSource" class="mb-3">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.first_name + ' ' + element.last_name }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef>Address</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element.address.address_line_1 && element.address.city">
                                {{ element.address.address_line_1 + ', ' + element.address.city }}
                            </ng-container>
                            <ng-container *ngIf="element.address.address_line_1 && !element.address.city">
                                {{ element.address.address_line_1 }}
                            </ng-container>
                            <ng-container *ngIf="!element.address.address_line_1 && element.address.city">
                                {{ element.address.city }}
                            </ng-container>
                            <ng-container *ngIf="!element.address.address_line_1 && !element.address.city">
                                Not Provided
                            </ng-container>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef>Email</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.email }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="phone_number">
                        <th mat-header-cell *matHeaderCellDef>Phone</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.phone_number }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="verification_package">
                        <th mat-header-cell *matHeaderCellDef>Verification Package</th>
                        <td mat-cell *matCellDef="let element">
                            @if(verificationPackage) {
                                {{ verificationPackage.verification_package.name }}
                            }
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="verification_cost">
                        <th mat-header-cell *matHeaderCellDef>Verification Price</th>
                        <td mat-cell *matCellDef="let element">
                            @if(verificationPackage) {
                                {{ verificationPackage.price | currency }}
                            } @else {
                                {{ 0 | currency }}
                            }
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let element" class="actions-column">
                            <button 
                                mat-raised-button 
                                class="action-button align-items-center mx-2"
                                (click)="onEditGuestClick(element)">
                                <mat-icon class="edit-button-icon">edit</mat-icon>
                                Edit
                            </button>
                            <button 
                                mat-raised-button class="warn-button align-items-center"
                                (click)="openConfirmDeleteGuestDialog(element)">
                                <mat-icon class="delete-button-icon">delete</mat-icon>
                                Delete
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columnsProps"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnsProps;"></tr>
                </table>
            </div>
        </div>
    </div>
    <div class="mx-2">
        <div class="row">
            <div class="col d-flex flex-column"></div>
            <div class="col d-flex flex-column">
                <div class="col-12 d-flex mt-2 me-1 justify-content-end">
                    <button mat-raised-button class="action-button" 
                    (click)="onAddGuestClick()">
                    <mat-icon>add</mat-icon>
                        Add Guest
                    </button>
                </div>
            </div>
        </div>
    </div>
</mat-expansion-panel>